module.exports = __webpack_public_path__ + "static/media/sprain-massage.163594bc.webp";